export class Tick {
  id: string;
  mark: number | null;

  constructor(tick: number, isMark: boolean) {
    this.id = String(tick);
    this.mark = isMark ? tick : null;
  }
}
